<template>
  <div class="contact-page">
    <h1 class="page-title">Contact LearnNow</h1>
    <div class="contact-grid">
      <div class="contact-panel contact-panel--info">
        <h3>Connect With Us</h3>
        <p>
          We are here to help and answer any questions you may have. Send us a message and we will get back to you as soon as possible.
        </p>
        <div class="contact-details">
          <p><strong>Email</strong></p>
          <p>kazbanj@yahoo.com</p>
        </div>
      </div>

      <div class="contact-panel contact-panel--form">
        <h3>Send a Message</h3>
        <form class="contact-form" @submit.prevent="submitMessage">
          <label for="name">Name</label>
          <input id="name" type="text" v-model="name" placeholder="Your name" />

          <label for="email">Email</label>
          <input id="email" type="email" v-model="email" placeholder="Your email" />

          <label for="message">Message</label>
          <textarea id="message" rows="6" v-model="message" placeholder="Write your message here..."></textarea>

          <button type="submit" class="emailbtn">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      message: '',
    };
  },
  methods: {
    submitMessage() {
      if (!this.name || !this.email || !this.message) {
        return alert('Please enter your name, email, and message before sending.');
      }
      const subject = encodeURIComponent('LearnNow Contact Message');
      const body = encodeURIComponent(`Name: ${this.name}\nEmail: ${this.email}\n\n${this.message}`);
      window.location.href = `mailto:kazbanj@yahoo.com?subject=${subject}&body=${body}`;
    },
  },
};
</script>

<style scoped>
.contact-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 2.5rem 1.25rem;
}

.page-title {
  text-align: center;
  margin-bottom: 1.75rem;
  font-size: 2.1rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.contact-panel {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1rem;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);
  padding: 1.75rem;
}

.contact-panel--info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.contact-panel--form {
  display: flex;
  flex-direction: column;
}

.contact-details {
  margin-top: 1.5rem;
  color: var(--color-text);
}

.contact-form {
  display: grid;
  gap: 1rem;
}

.contact-form label {
  font-weight: 700;
  margin-bottom: 0.35rem;
  display: inline-block;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  border: 1px solid var(--color-border);
  border-radius: 0.75rem;
  padding: 0.9rem 1rem;
  font: inherit;
  color: var(--color-text);
  background: #fff;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.12);
}

.contact-form .emailbtn {
  width: fit-content;
}

@media (min-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr 1.1fr;
  }
}
</style>
